import { Timestamp } from 'firebase/firestore';

/**
 * Estructura de un evento en Firestore
 */
export interface Event {
  id: string;
  information: string;
  createdByEmail?: string;
  information2: string;
  date: Timestamp;
  schedule_start: string;
  schedule_finish: string;
  price: number;
  currency?: string;
  lat: number;
  long: number;
  address_id: string;
  photoItem: string;
  photoPortrait: string;
  videoUrl?: string;
  status: number;
  published: boolean;
  createdBy: string;
  paymentId?: string;
  paymentAmount?: number; 
  paymentCurrency?: string; 
  createdAt: Timestamp;
  updatedAt: Timestamp;
  geohash?: string;
  artist_id?: string;
  searchKeywords?: string[];
  likes?: string[];
  expired?: boolean;
}

/**
 * Datos para crear un nuevo evento
 */
export interface CreateEventData {
  information: string;
  information2: string;
  date: Date;
  schedule_start: string;
  schedule_finish: string;
  price: number;
  currency?: string;
  address_id: string;
  lat: number;
  long: number;
  photoItem: string;
  photoPortrait: string;
  videoUrl: string;
  createdBy: string;
  createdByEmail?: string;
  paymentAmount?: number;
  paymentCurrency?: string;
  publishDirectly?: boolean;
}

/**
 * Estados posibles de un evento
 */
export enum EventStatus {
  DRAFT = 0,
  PUBLISHED = 1,
  PENDING_MODERATION = 2,
  REJECTED = 3,
  EXPIRED = 4,
  APPROVED = 5   // aprobado por moderador, esperando que el organizador ingrese el token
}

/**
 * Datos para actualizar un evento existente
 */
export interface UpdateEventData {
  information?: string;
  information2?: string;
  date?: Date;
  schedule_start?: string;
  schedule_finish?: string;
  price?: number;
  currency?: string;
  address_id?: string;
  lat?: number;
  long?: number;
  photoItem?: string;
  photoPortrait?: string;
  videoUrl?: string;
}

/**
 * Datos del formulario de creación (antes de convertir a CreateEventData)
 */
export interface EventFormData {
  title: string;
  description: string;
  date: string;
  startTime: string;
  endTime: string;
  price: string;
  currency: string;
  address: string;
  lat: number;
  lng: number;
}

export interface Currency {
  code: string;
  symbol: string;
  name: string;
}

